import axios from 'axios';

export const createReport = (projectId, params) => axios.post(`/projects/${projectId}/reports`, params);
export const deleteReport = (projectId, reportId) => axios.delete(`/projects/${projectId}/reports/${reportId}`);
